import { KeyValue } from '@app/core/types/key-value.type'
import { countColumns } from './count-columns.utils'
import { Preference } from '@app/core/model/user-preferences.interface'

export function calculateColumnClass(columns: KeyValue<Preference> | Preference[]): string {
  const count = countColumns(columns)
  return getColumnClass(count)
}

export function getColumnClass(count: number) {
  switch (count) {
    case 0:
      return 'eleven--columns'
    case 1:
      return 'ten--columns'
    case 2:
      return 'nine--columns'
    case 3:
      return 'eight--columns'
    case 4:
      return 'seven--columns'
    case 5:
      return 'six--columns'
    case 6:
      return 'five--columns'
    case 7:
      return 'four--columns'
    case 8:
      return 'three--columns'
    case 9:
    default:
      return 'two--columns'
  }
}
